/* eslint-disable react/no-did-update-set-state */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import AutoCompleteMenu from 'components/AutoCompleteMenu';
import { FormError, FormLabel } from 'components/Form';
import AutoCompleteDefaultSelectedItem from './AutoCompleteDefaultSelectedItem';

import './style.scss';

export class AutoCompleteMenuWrapper extends Component {
  static propTypes = {
    autoCompleteItemComponent: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.object,
    ]),
    autoCompleteSelectedItemComponent: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.object,
    ]),
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    input: PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
      ]),
      onChange: PropTypes.func,
    }),
    isArchived: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    itemDisabledReason: PropTypes.string,
    itemIndexOffset: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        archived: PropTypes.bool,
        name: PropTypes.string,
      }),
    ),
    itemUniqueProp: PropTypes.string,
    itemWithIndex: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.shape({
      error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      touched: PropTypes.bool,
    }),
    name: PropTypes.string,
    placeholder: PropTypes.string,
    renderOverView: PropTypes.func,
    selectItem: PropTypes.func,
    withAddOption: PropTypes.string,
    withDropCross: PropTypes.bool,
    onChangeValue: PropTypes.func,
    onClickAddOption: PropTypes.func,
    onOpen: PropTypes.func,
  };

  static defaultProps = {
    autoCompleteSelectedItemComponent: AutoCompleteDefaultSelectedItem,
    autoFocus: false,
    renderOverView: null,
    withDropCross: false,
    item: '',
    itemWithIndex: false,
    itemIndexOffset: 0,
    itemUniqueProp: 'id',
    itemDisabledReason: 'Archived Item!',
    isDisabled: false,
    onOpen: () => {},
    selectItem: () => {},
  };

  state = {
    isOpen: false,
    searchTerm: '',
  };

  componentDidMount = () => {
    const { autoFocus, onOpen } = this.props;
    if (autoFocus) {
      this.setState({ searchTerm: '', isOpen: true }, onOpen);
    }
  };

  componentDidUpdate = nextProps => {
    const { isOpen } = this.state;
    const { autoFocus } = this.props;

    if (autoFocus && !nextProps.input.value && !isOpen) {
      this.setState({ searchTerm: '', isOpen: true });
    }
  };

  handleClose = item => {
    const { input } = this.props;
    input.onChange(item);
    this.setState({
      isOpen: false,
    });
  };

  handleOpen = e => {
    const { isDisabled, onOpen } = this.props;
    if (isDisabled) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    this.setState({ searchTerm: '', isOpen: true }, onOpen);
  };

  handleReset = e => {
    const { input } = this.props;
    e.stopPropagation();
    input.onChange(null);
  };

  handleChangeValue = value => {
    const { onChangeValue } = this.props;
    this.setState(
      {
        searchTerm: value,
      },
      () => {
        if (typeof onChangeValue === 'function') {
          onChangeValue(value);
        }
      },
    );
  };

  handleSelectItem = item => {
    const { selectItem } = this.props;
    this.handleClose(item);
    selectItem(item);
  };

  handleClickAddOption = () => {
    const { onClickAddOption } = this.props;
    this.handleClose();
    if (typeof onClickAddOption === 'function') {
      onClickAddOption();
    }
  };

  renderAutocomplete() {
    const { isOpen, searchTerm } = this.state;
    const {
      autoCompleteSelectedItemComponent: AutoCompleteSelectedItemComponent,
      autoCompleteItemComponent,
      input,
      items,
      itemWithIndex,
      itemIndexOffset,
      itemUniqueProp,
      placeholder,
      isLoading,
      isArchived,
      isDisabled,
      renderOverView,
      item, // FIXME: drop it
      itemDisabledReason,
      withDropCross,
      withAddOption,
      meta: { touched, error },
    } = this.props;

    if (!isOpen) {
      return (
        <button
          data-test="autocomplete-button"
          disabled={isDisabled}
          styleName={cn('fake-autocomplete', {
            invalid: touched && error,
            'is-archived': isArchived,
          })}
          type="button"
          onClick={this.handleOpen}
          onKeyDown={this.handleOpen}
        >
          <AutoCompleteSelectedItemComponent
            input={input}
            item={item}
            itemIndexOffset={itemIndexOffset}
            items={items}
            itemUniqueProp={itemUniqueProp}
            itemWithIndex={itemWithIndex}
            placeholder={placeholder}
            withDropCross={withDropCross}
            onClearButtonClick={this.handleReset}
          />
        </button>
      );
    }

    return (
      <AutoCompleteMenu
        autoCompleteItemComponent={autoCompleteItemComponent}
        changeValue={this.handleChangeValue}
        isLoading={isLoading}
        isOpen={isOpen}
        itemDisabledReason={itemDisabledReason}
        itemIndexOffset={itemIndexOffset}
        items={items.map(({ archived, ...restProps }, index) => ({
          ...restProps,
          index,
          disabled: archived,
        }))}
        itemWithIndex={itemWithIndex}
        placeholder={placeholder}
        renderOverView={renderOverView}
        searchTerm={searchTerm}
        selectItem={this.handleSelectItem}
        withAddOption={withAddOption}
        onClickAddOption={this.handleClickAddOption}
        onClose={this.handleClose}
      />
    );
  }

  render() {
    const {
      label,
      name,
      meta: { touched, error },
      className,
    } = this.props;

    return (
      <div className={className}>
        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
        {this.renderAutocomplete()}
        {touched && error && <FormError>{error}</FormError>}
      </div>
    );
  }
}

export default AutoCompleteMenuWrapper;
